import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'
import { Grid } from '@mui/material'

/** COMPONENT */
import InputTextField from 'component/Input/InputTextField'

export interface FormCareerLineInterface {
  error?: any
  resetErrorMessage: () => void
}

export default function FormCareerLine(props: FormCareerLineInterface) {
  const { t } = useTranslation()
  const { register } = useFormContext()

  const [careerLineName, setCareerLineName] = useState('')
  const [careerLineNameEn, setCareerLineNameEn] = useState('')

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} className={'w-100'}>
          <InputTextField
            key="career-line-name"
            register={register(`careerLineName`, {
              value: careerLineName,
              onChange: (event) => {
                setCareerLineName(event.target.value)
              }
            })}
            onchange={(event) => {
              setCareerLineName(event.target.value)
              props.resetErrorMessage()
            }}
            onkeypress={(event) => {
              setCareerLineName(event.target.value)
              props.resetErrorMessage()
            }}
            value={careerLineName}
            label={t('CAREER_LINE.INPUT.CAREER_LINE_NAME')}
            helperText={props.error.CAREER_LINE_NAME || props.error.IS_DUPLICATE_CAREER_LINE_NAME || props.error.CAREER_LINE_NAME_STRING_BASE || props.error.CAREER_LINE_NAME_STRING_EMPTY || props.error.CAREER_LINE_NAME_MAXIMUM_LENGTH || props.error.CAREER_LINE_NAME_ANY_REQUIRED}
            required
          />
        </Grid>
        <Grid item xs={12} className={'w-100'}>
          <InputTextField
            key="career-line-name-en"
            register={register(`careerLineNameEn`, {
              value: careerLineNameEn,
              onChange: (event) => {
                setCareerLineNameEn(event.target.value)
              }
            })}
            onchange={(event) => {
              setCareerLineNameEn(event.target.value)
              props.resetErrorMessage()
            }}
            onkeypress={(event) => {
              setCareerLineNameEn(event.target.value)
              props.resetErrorMessage()
            }}
            value={careerLineNameEn}
            helperText={
              props.error.CAREER_LINE_NAME_EN ||
              props.error.IS_DUPLICATE_CAREER_LINE_NAME_EN ||
              props.error.CAREER_LINE_NAME_EN_STRING_BASE ||
              props.error.CAREER_LINE_NAME_EN_STRING_EMPTY ||
              props.error.CAREER_LINE_NAME_EN_MAXIMUM_LENGTH ||
              props.error.CAREER_LINE_NAME_EN_ANY_REQUIRED
            }
            label={t('CAREER_LINE.INPUT.CAREER_LINE_NAME_EN')}
            required={false}
          />
        </Grid>
      </Grid>
    </div>
  )
}
